import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

// Initialize axios with token from localStorage immediately
const initToken = localStorage.getItem('token');
if (initToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${initToken}`;
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(initToken);
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      console.log('✅ JWT token set in axios headers');
    } else {
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      console.log('🔓 JWT token removed from axios headers');
    }
  }, [token]);

  const login = async (email, password) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
      email,
      password
    });
    const userData = response.data.data.user;
    const newToken = response.data.data.token;

    setToken(newToken);
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', newToken);

    console.log('✅ User logged in:', userData.email);
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    console.log('👋 User logged out');
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}
